<template>
  <b-card-code
      title="Új hozzáadása"
  >
    <b-overlay
        :show="loading"
        spinner-variant="primary"
        spinner-type="grow"
        rounded="sm"
    >
      <!-- form -->
      <validation-observer ref="simpleRules">
        <b-form>
          <b-row>
            <b-col :md="formData.type.value === 'event' ? '4' : '6'">
              <b-form-group
                  label="Cím"
              >
                <validation-provider
                    #default="{ errors }"
                    name="cím"
                    rules="required"
                    vid="title"
                >
                  <b-form-input
                      v-model="formData.title"
                      :state="errors.length > 0 ? false:null"
                      placeholder="cím"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>

            <b-col v-if="formData.type.value !== 'event'" md="6">
              <b-form-group
                  label="Dátum"
              >
                <validation-provider
                    #default="{ errors }"
                    name="dátum"
                    rules=""
                    vid="date"
                >
                  <flat-pickr
                      v-model="formData.date"
                      class="form-control"
                      :config="flatPickRConfig"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>

            <b-col v-if="formData.type.value === 'event'" md="4">
              <b-form-group
                  label="Kezdő dátum"
              >
                <validation-provider
                    #default="{ errors }"
                    name="kezdő dátum"
                    rules=""
                    vid="start_date"
                >
                  <flat-pickr
                      v-model="formData.start_date"
                      class="form-control"
                      :config="flatPickRConfig"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>

            <b-col v-if="formData.type.value === 'event'" md="4">
              <b-form-group
                  label="Befejező dátum"
              >
                <validation-provider
                    #default="{ errors }"
                    name="befejező dátum"
                    rules=""
                    vid="end_date"
                >
                  <flat-pickr
                      v-model="formData.end_date"
                      class="form-control"
                      :config="flatPickRConfig"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>

            <b-col md="6">
              <b-form-group
                  label="Típus"
              >
                <validation-provider
                    #default="{ errors }"
                    name="típus"
                    rules="required"
                    vid="type"
                >
                  <v-select
                      v-model="formData.type"
                      :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                      label="title"
                      :options="typeOptions"
                      @input="typeChanged"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>

            <b-col md="6">
              <b-form-group
                  label="Státusz"
              >
                <validation-provider
                    #default="{ errors }"
                    name="státusz"
                    rules="required"
                    vid="status"
                >
                  <v-select
                      v-model="formData.status"
                      :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                      label="title"
                      :options="statusOptions"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>

            <b-col md="12">
              <b-form-group
                  label="Címke"
              >
                <validation-provider
                    #default="{ errors }"
                    name="címke"
                    vid="tags"
                >
                  <v-select
                      v-model="formData.tags"
                      :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                      label="title"
                      multiple
                      taggable
                      push-tags
                      :options="tagOptions"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>

            <b-col md="12">
              <b-form-group
                  label="Szöveg"
              >
                <validation-provider
                    #default="{ errors }"
                    name="szöveg"
                    rules="required"
                    vid="content"
                >
                  <editor
                      v-model="formData.content"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>

            <!-- submit button -->
            <b-col class="mt-1">
              <b-button
                  variant="primary"
                  type="submit"
                  class="float-right"
                  @click.prevent="submitForm"
              >
                Mentés
              </b-button>
              <cancel-and-g-o-t-o-previous-page class="mr-2"/>
            </b-col>
          </b-row>
        </b-form>
      </validation-observer>
    </b-overlay>
  </b-card-code>
</template>

<script>
import BCardCode from '@core/components/b-card-code'
import {ValidationProvider, ValidationObserver} from 'vee-validate'
import {
  BFormInput,
  BFormGroup,
  BForm,
  BRow,
  BCol,
  BButton,
  BFormCheckbox,
  BFormDatepicker,
  BInputGroup,
  BInputGroupAppend,
  BLink,
  BOverlay,
} from 'bootstrap-vue'
import {
  required,
} from '@validations'
import vSelect from 'vue-select'
import editor from '@/views/pages/_components/editor.vue'
import cancelAndGOTOPreviousPage from '@/views/pages/_components/_helper/cancelAndGOTOPreviousPage'
import flatPickr from 'vue-flatpickr-component'
import 'flatpickr/dist/flatpickr.css';
import {Hungarian} from 'flatpickr/dist/l10n/hu.js'

export default {
  components: {
    BOverlay,
    BCardCode,
    ValidationProvider,
    ValidationObserver,
    BFormInput,
    BFormGroup,
    BForm,
    BRow,
    BCol,
    BButton,
    BFormCheckbox,
    flatPickr,
    BLink,
    vSelect,
    editor,
    cancelAndGOTOPreviousPage,
  },
  data() {
    return {
      role: 'document_library',
      formData: {
        title: '',
        tags: [],
        type: '',
        content: '',
        date: '',
        start_date: '',
        end_date: '',
        status: '',
      },
      flatPickRConfig: {
        enableTime: true,
        dateFormat: 'Y-m-d H:i',
        locale: Hungarian,
        allowInput: true
      },
      tagOptions: [],
      statusOptions: [],
      typeOptions: [],
      loading: false,
      required,
    }
  },
  created() {
    this.loading = true
    this.$store.dispatch('fetchAllTagsForBootstrap').then(response => {
      this.tagOptions = response
    })

    this.$store.dispatch('documentLibraryStatuses').then(response => {
      this.statusOptions = response.data.values
      this.formData.status = this.statusOptions[0]
    })

    this.$store.dispatch('documentLibraryTypes').then(response => {
      this.typeOptions = response.data.values
      this.formData.type = this.typeOptions[0]
    }).finally(() => {
      this.loading = false
    })
  },
  methods: {
    typeChanged() {
      if (this.formData.type.value === 'event') {
        this.formData.date = ''
      } else {
        this.formData.start_date = ''
        this.formData.end_date = ''
      }
    },
    submitForm() {
      this.$refs.simpleRules.validate().then(success => {
        if (success) {
          this.loading = true
          let fd = {...this.formData}
          fd.status = this.formData.status.value
          fd.type = this.formData.type.value

          this.$store.dispatch('storeDocumentLibrary', fd).then(response => {
            this.$helpers.showSuccessToast()

            this.$acl.canListPermission(this.role)
                ? this.$router.push({name: 'modify-document-library', params: {id: response.data.entity.id}})
                : this.$router.go(-1)
          }).catch(error => {
            if (error.response.status === 422) {
              this.$refs.simpleRules.setErrors(error.response.data.errors)
            } else {
              this.$helpers.showErrorToast(error.toString())
            }
          }).finally(() => {
            this.loading = false
          })
        }
      })
    },
  },
}
</script>

<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';
</style>
